<template>
   <div class="card">
      <h6>YOUR USAGE</h6>
      <h4>How much energy do you think you'll consume in your new home?</h4>

      <p>
         We can estimate your annual energy consumption using averages provided by Ofgem the UK's energy regulator.
      </p>

      <div class="row _margin-top-30">
         <div class="col-xs-4 col-md-4" v-for="item in ofgemAverages" :key="item.label">
            <radio-button v-model="quote.usage" :value="item.label" :error="$v.usage.$error"
               @change="onUsageChange(item)">
               {{ item.label }}
            </radio-button>

            <p style="font-size: 12px;" class="_margin-top-0">{{ item.description }}</p>
         </div>
      </div>
   </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState, mapGetters } from 'vuex';

export default {
   name: 'Usage',
   props: {
      $v: Object
   },
   computed: {
      ...mapGetters({
         is02Meter: 'quote/is02Meter'
      }),
      ...mapState({
         ofgemAverages: ({ ofgem_averages }) => ofgem_averages.averages.calculation,
         quote: ({ quote }) => quote
      })
   },
   methods: {
      onUsageChange(item) {
         this.quote.gasUsage.usage = null;
         this.quote.electricityUsage.usage = null;

         switch (this.quote.compareFuel) {
            case 'gasElectricity':
               this.quote.gasUsage.usage = item.gas;
               this.quote.electricityUsage.usage = this.handleElectricityUsage(item);
               break;

            case 'electricity':
               this.quote.electricityUsage.usage = this.handleElectricityUsage(item);
               break;

            case 'gas':
               this.quote.gasUsage.usage = item.gas;
               break;

            default:
               this.quote.gasUsage.usage = item.gas;
               this.quote.electricityUsage.usage = this.handleElectricityUsage(item);
               break;
         }
      },
      handleElectricityUsage(item) {
         if (this.is02Meter) {
            return item.electricity02;
         } else {
            return item.electricity01;
         }
      }
   },
   components: {
      RadioButton
   }
};
</script>

<style lang="scss"></style>
